import { Checkbox, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useEffect, useState } from 'react';
import { Loading, ResourceDefinitions, TextInputProps, useRecordContext, useResourceDefinitions, useTranslate } from 'react-admin';
import { useFormContext } from 'react-hook-form';

type AclAction = 'list' | 'show' | 'create' | 'edit' | 'export' | 'delete' | 'clone' | 'read' | 'write';
type Data_Type = 'deny';

// const AclActionDependency = (resource: ResourceDefinitions, action: AclAction) => {
//   if (!resource.hasList) {
//     return false;
//   }
// };

interface DataRow {
  action: Array<AclAction>,
  resource: string,

  type?: Data_Type,
  record?: { [key: string]: any },
}

type Data = Array<DataRow>;

const log = (...args) => console.log('SimpleResourceACLInput', ...args);

export interface SimpleResourceACLInputProps extends TextInputProps {
}

const SimpleResourceACLInput = (props: SimpleResourceACLInputProps) => {
  const { source } = props;
  const record = useRecordContext();
  const { setValue } = useFormContext();
  const translate = useTranslate();
  const resourcesDefinitions = useResourceDefinitions<ResourceDefinitions>();
  const resources = Object.keys(resourcesDefinitions).map(name => resourcesDefinitions[name]);
  const [stateByName, setStateByName] = useState<{ [name: string]: DataRow }>();

  useEffect(() => {
    let stateRecord = Object.fromEntries((record[source] as Data).map(({ resource, ...rest }) => ([resource, rest])));
    let stateTemp = resources.map(({ name, }) => ({ resource: name, action: [], ...stateRecord[name] }));
    setStateByName(o => Object.fromEntries(stateTemp.map(({ resource, ...rest }) => ([resource, { resource, ...rest }]))));
    // log(resourcesDefinitions, resources);
  }, []);

  const onCheckboxClick = (resource: ResourceDefinitions, action: AclAction) => {
    setStateByName(o => {
      const i = o[resource.name].action.indexOf(action);
      if (-1 === i) {
        o[resource.name].action.push(action);
      } else {
        o[resource.name].action.slice(i, 1);
      }
      setValue(source, Object.entries(o).map(([resource, rest]) => ({ ...rest })));
      return { ...o };
    });
  }

  // const onCheckboxAllClick = (resource: ResourceDefinitions) => {
  //
  // }

  if (!stateByName) {
    return <Loading />;
  }

  return (
    <>
      <Table width={'100%'}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ flex: 1 }}>Name</TableCell>
            {/* <TableCell>All</TableCell> */}
            <TableCell>List</TableCell>
            {/* <TableCell>Create</TableCell> */}
            {/* <TableCell>Edit</TableCell> */}
            {/* <TableCell>Delete</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {resources.map((resource) => {
            return <TableRow key={resource.name}>
              <TableCell>{translate(`resources.${resource.name}.name`)}</TableCell>
              {/* <TableCell><Checkbox onClick={() => onCheckboxAllClick(resource)} /></TableCell> */}
              <TableCell><Checkbox disabled={!resource.hasList} checked={-1 !== stateByName[resource.name].action.indexOf('list')} onClick={() => onCheckboxClick(resource, 'list')} /></TableCell>
              {/* <TableCell><Checkbox disabled={!resource.hasCreate} checked={-1 !== stateByName[resource.name].action.indexOf('create')} onClick={() => onCheckboxClick(resource, 'create')} /></TableCell> */}
              {/* <TableCell><Checkbox disabled={!resource.hasEdit} checked={-1 !== stateByName[resource.name].action.indexOf('edit')} onClick={() => onCheckboxClick(resource, 'edit')} /></TableCell> */}
              {/* <TableCell><Checkbox disabled={!resource.hasEdit} checked={-1 !== stateByName[resource.name].action.indexOf('delete')} onClick={() => onCheckboxClick(resource, 'delete')} /></TableCell> */}
            </TableRow>
          })}
        </TableBody>
      </Table>
    </>
  );
}

SimpleResourceACLInput.defaultProps = {
}

export default SimpleResourceACLInput;
